import React from 'react';
import style from '../styling/LayoutCommon.module.css';

export default function Footer () {
	return (
		<div className={ style.footer }>
			<hr />
			<p>&copy; Habitat Learn 2021</p>
		</div>
	)
}